import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Container, Grid } from "@mui/material";

import "./css/main.css";
import Banner from "./Components/Banner";
import Footer from "./Components/Footer";
import InactivityHandler from "./Components/InactivityHandler";
import { TranslationProvider } from "./Components/TranslationContext";
import Appartments from "./Pages/Appartments";
import Login from "./Pages/Login";
import Signin from "./Pages/Signin";
import PasswordReset from "./Pages/PasswordReset";
import Logout from "./Pages/Logout";
import User from "./Pages/User";
import Renew from "./Pages/Renew";
import RecoverableCharges from "./Pages/RecoverableCharges";
import ContractCharges from "./Pages/ContractCharges";
import Rents from "./Pages/Rents";
import RentChargesAdjustment from "./Pages/RentChargesAdjustment";
import Tenants from "./Pages/Tenants";
import Contracts from "./Pages/Contracts";
import NotFound from "./Pages/NotFound";
import ContractPrices from "./Pages/ContractPrices";
import RentsAndChargesSummary from "./Pages/RentsAndChargesSummary";
import AdminUsers from "./Pages/Admin/Users";
import AdminAccessAttempts from "./Pages/Admin/AccessAttempts";
import * as constants from "./utils/constants";
import mainTheme from "./Theme";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

const paypalOptions = {
  "client-id": constants.PAYPAL_CLIENT_ID,
  currency: "EUR",
  intent: "capture",
};

function App() {
  let [, setToken] = useState();
  const [translations] = useState({});
  document.title = translations.app_title || "Locabel";

  return (
    <PayPalScriptProvider options={paypalOptions}>
      <ThemeProvider theme={mainTheme}>
        <TranslationProvider>
          <Router
            future={{
              v7_relativeSplatPath: true,
              v7_startTransition: true,
            }}
          >
            <InactivityHandler>
              <Container>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <Banner></Banner>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <div id="container" className="mainContainer">
                      <Routes>
                        <Route path="/" element={<Login setToken={setToken} />} />
                        <Route path="/Rents" element={<Rents />} />
                        <Route path="/Appartments" element={<Appartments />} />
                        <Route path="/ContractPrices/:contract_id/:appName" Component={ContractPrices} />
                        <Route path="/Tenants" element={<Tenants />} />
                        <Route path="/Contracts" element={<Contracts />} />
                        <Route path="/Login" element={<Login setToken={setToken} />} />
                        <Route path="/Logout" element={<Logout setToken={setToken} />} />
                        <Route path="/Signin" element={<Signin setToken={setToken} />} />
                        <Route path="/PasswordReset/:reset_token" element={<PasswordReset />} />
                        <Route path="/User" element={<User />} />
                        <Route path="/Renew" element={<Renew />} />
                        <Route path="/RecoverableCharges" element={<RecoverableCharges />} />
                        <Route path="/RentChargesAdjustment/:contract_id" element={<RentChargesAdjustment />} />
                        <Route path="/ContractCharges/:contract_id/:appName" Component={ContractCharges} />
                        <Route path="/RentAndChargesSummary" element={<RentsAndChargesSummary />} />
                        <Route path="/AdminUsers" element={<AdminUsers />} />
                        <Route path="/AdminAccessAttempts/:user_id" element={<AdminAccessAttempts />} />
                        <Route path="*" element={<NotFound />} />
                      </Routes>
                      <Footer></Footer>
                    </div>
                  </Grid>
                </Grid>
              </Container>
            </InactivityHandler>
          </Router>
        </TranslationProvider>
      </ThemeProvider>
    </PayPalScriptProvider>
  );
}

export default App;
